import { Link } from 'react-router-dom';
import { ShieldCheck, Zap, Cpu, Leaf, Wrench, Headphones } from 'lucide-react';
import { features } from '../mock';

const iconMap = { ShieldCheck, Zap, Cpu, Leaf, Wrench, Headphones };

export default function Features() {
  return (
    <section className="section-pad bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <p className="text-xs tracking-[0.25em] text-px-red font-semibold mb-3">
            MENGAPA POWERX
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
            Daya Andal, Kinerja Optimal
          </h2>
          <p className="text-neutral-600 leading-relaxed text-lg mb-4">
            PowerX menghadirkan produk dan solusi daya yang mengutamakan kualitas, keamanan, dan keandalan. Setiap produk dipilih dan dikembangkan untuk memberikan performa yang optimal serta mendukung kebutuhan daya dan energi secara berkelanjutan.
          </p>
          <p className="text-neutral-600 leading-relaxed text-lg">
            Dengan dukungan produk yang lengkap dan layanan yang responsif, PowerX siap menjadi solusi untuk kebutuhan rumah, bisnis, hingga industri.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={i}
                className="group bg-white rounded-2xl p-8 border border-neutral-200 hover-lift hover:border-neutral-300"
              >
                <div className="w-12 h-12 rounded-xl bg-red-50 group-hover:bg-px-red flex items-center justify-center mb-5 transition-colors duration-300">
                  <Icon className="w-6 h-6 text-px-red group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-display text-xl font-bold text-neutral-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          <Link
            to="/about"
            className="inline-flex items-center bg-neutral-900 hover:bg-px-red text-white text-sm font-semibold px-7 py-3.5 rounded-full transition-colors"
          >
            Pelajari Perusahaan Kami
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center border border-neutral-300 hover:border-neutral-900 text-neutral-900 text-sm font-semibold px-7 py-3.5 rounded-full transition-colors"
          >
            Bicara dengan Engineer
          </Link>
        </div>
      </div>
    </section>
  );
}
